import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';
import { SezioneBeniImmobili } from '../../../models/sezioni/sezione-beni-immobili';
import { BeniImmobiliAddComponent } from './beni-immobili-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [beni-immobili-mod-add]',
  templateUrl: 'beni-immobili-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class BeniImmobiliModAddComponent {
  @Output() onReturn: EventEmitter<SezioneBeniImmobili> = new EventEmitter<SezioneBeniImmobili>();
  @ViewChild('formBeniAddImmobili') formBeniImmobili: BeniImmobiliAddComponent;

  inizializza(idSezione: string, idFascicolo: string, urlAdd: string, beneImmobile: BenePignoratoImmobile) {
    this.formBeniImmobili.inizializza(idSezione, idFascicolo , urlAdd, beneImmobile);
    openModal('modalmodaddbenimmobili');
  }

  createForm() {
    this.formBeniImmobili.createForm();
  }

  manageModal(sezioneBeniImmobili: SezioneBeniImmobili) {
      closeModal('modalmodaddbenimmobili');
      this.onReturn.emit(sezioneBeniImmobili);
  }
}
